import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function PoslovnaEkonomija() {
  const [t] = useTranslation();

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Menadžment javnog sektora" />
      <section className="project-detail">
        <div className="container">
          <div className="lower-content">
            <div className="row">
              <div className="text-column col-lg-9 col-md-9 col-sm-12">
                <h2>{t("specmjs.title")}</h2>
                <div className="upper-box">
                  <div className="single-item-carousel owl-carousel owl-theme">
                    <figure className="image">
                      <img
                        src="assets/img/bg/Fpep-05.png"
                        alt="menadzmentjavnogsektora slika"
                      />
                    </figure>
                  </div>
                </div>
                <div className="inner-column textjustify">
                  <h3>{t("programi.subtitle1")}</h3>
                  <p>{t("specmjs.opisprograma")}</p>
                  <h4>{t("programi.subtitle2")}</h4>
                  <p>{t("specmjs.stacetenauciti")}</p>

                  <ul className="pr-ul">
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit1")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit2")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit3")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit4")}</div>
                    </li>
                  </ul>

                  <h3>{t("programi.sadrzajPredmeta")}</h3>

                  <div
                    className="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="accordion" id="accordionExample">
                      <div className="card">
                        <div className="card-header" id="headingThree">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 0 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse0"
                              onClick={() => handleToggle(0)}
                            >
                              {t("programi.prvaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse0"
                          className={`collapse${
                            activeIndex === 0 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvagodina.specmjs1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvagodina.specmjs2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvagodina.specmjs3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvagodina.specmjs4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izborni1")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.istrazivackispec")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.specijalistickirad")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingFour">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 2 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2"
                              onClick={() => handleToggle(2)}
                            >
                              {t("programi.prvaIzborna")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse2"
                          className={`collapse${
                            activeIndex === 2 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvaizborna.specmjs1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvaizborna.specmjs2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvaizborna.specmjs3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvaizborna.specmjs4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>

                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />
                                      {t("prvaizborna.specmjs5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <aside className="sidebar-widget info-column">
                  <div className="inner-column3">
                    <h3>{t("programi.osnovneinfo")}</h3>
                    <ul className="project-info clearfix">
                      <li>
                        <div className="priceing">
                          <strong>€1700.00</strong>{" "}
                          <h6>/{t("programi.jednokratno")}</h6>
                        </div>
                        <div className="priceingnarate">
                          <strong>€1700.00</strong>{" "}
                          <h6>/{t("programi.narate")}</h6>
                        </div>
                      </li>
                      <li>
                        <span className="icon fas fa-university" />{" "}
                        <strong>{t("programi.tipstudija")}</strong>{" "}
                        <span>{t("programi.akademske")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-calendar-alt" />{" "}
                        <strong>{t("programi.stepenstudija")}</strong>{" "}
                        <span>{t("programi.stepenspec")}</span>
                      </li>

                      <li>
                        <span className="icon fas fa-clock" />{" "}
                        <strong>{t("programi.trajanje")} </strong>{" "}
                        <span>{t("programi.trajanje1")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-graduation-cap" />{" "}
                        <strong>{t("programi.zvanje")}</strong>{" "}
                        <span>{t("specmjs.zvanje")}</span>
                      </li>
                      <li>
                        <div className="slider-btn">
                          <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLSejqXir_pUuSCp0MwDJLzLoTDiT2SphgLQPO8_-5t35dxh5lw/viewform"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn ss-btn smoth-scroll"
                          >
                            {t("programi.apply")}{" "}
                            <i className="fas fa-arrow-right" />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default PoslovnaEkonomija;
